import React, { Component } from "react";
import { Button, Modal, Form, Alert, FormControl, Spinner } from "react-bootstrap";
import "../Elements/Modal/Modal.css";
import "./RecordTagEditModal.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const MIN_CATEGORIES = 1;
const DEFAULT_CATEGORY_BG_COLOR = '#ED7C47';
const DEFAULT_CATEGORY_FONT_COLOR = '#ffffff';

export default class RecordTagEditModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: "",
            errorMessage: null,
            loading: false,
            isDropdownOpen: false,
            // ローカルの選択状態（APIレスポンスで更新）
            selectedCategories: [...(this.props.categories || [])],
            // topic設定（モーダルopen時に最新取得）
            topicOutputMax: null,
            loadingTopicOptions: true,
            // 分類マスタ（モーダルopen時に通話の持ち主基準で取得。#553）
            categoryMaster: [],
            loadingCategoryMaster: true,
        };
    }

    /**
     * 複数タグオプションが有効かどうか
     * state.topicOutputMax > 1 → 複数タグ有効
     * state.topicOutputMax <= 1 または未取得 → 単一タグモード（安全側）
     */
    isMultiTagEnabled = () => {
        const { topicOutputMax, loadingTopicOptions } = this.state;
        if (loadingTopicOptions || topicOutputMax === null) return false;
        return topicOutputMax > 1;
    }

    /**
     * 現在のモードでの最大選択数
     * 未取得時は安全側として1を返す
     */
    getMaxCategories = () => {
        const { topicOutputMax, loadingTopicOptions } = this.state;
        if (loadingTopicOptions || topicOutputMax === null) return 1;
        if (topicOutputMax > 1) return topicOutputMax;
        return 1;
    }

    /**
     * 最新のtopic設定を取得してstateに反映
     */
    fetchTopicOptions = async () => {
        try {
            const result = await this.props.ascAxios('post', 'Category/getTopicOptions', {});
            const topicOutputMax = result.data && result.data.topic_output_max != null
                ? result.data.topic_output_max
                : 1;
            this.setState({ topicOutputMax, loadingTopicOptions: false });
        } catch (err) {
            console.error("getTopicOptions error:", err);
            // エラー時は安全側（1=OFF）として扱う
            this.setState({ topicOutputMax: 1, loadingTopicOptions: false });
        }
    }

    /**
     * 分類マスタを「通話の持ち主」基準で取得する（#553）
     *
     * ログイン中の利用者の分類マスタ（props.categoryMaster）は、他人名義の通話では
     * 通話に付いている分類と ID 空間が一致せず、同名の分類が二重に並ぶ原因になる。
     * 取得に失敗した場合は、表示を止めないため props の分類マスタへ退避する。
     */
    fetchCategoryMaster = async () => {
        try {
            const result = await this.props.ascAxios('post', 'Record/getCategoryMasterByHt60Id', {
                ht60_id: this.props.ht60_id,
                offset: 0,
                limit: 1000
            });
            const rows = (result && result.data && result.data.rows) || [];
            this.setState({
                categoryMaster: rows.map(category => ({
                    value: category.name,
                    label: category.name,
                    rgb: category.rgb || DEFAULT_CATEGORY_BG_COLOR,
                    font_rgb: category.font_rgb || DEFAULT_CATEGORY_FONT_COLOR,
                    data: category
                })),
                loadingCategoryMaster: false
            });
        } catch (err) {
            console.error("getCategoryMasterByHt60Id error:", err);
            this.setState({
                categoryMaster: [...(this.props.categoryMaster || [])],
                loadingCategoryMaster: false
            });
        }
    }

    /**
     * 初回マウント時のtopic設定取得
     * RecordTagEditModal は case "tagEdit" のときだけレンダリングされるため、
     * 最初のタグ編集ボタンクリック時は show: true の状態でマウントされる。
     * componentDidUpdate は初回マウント時に呼ばれないため、ここで fetchTopicOptions を実行する。
     */
    componentDidMount() {
        if (this.props.state && this.props.state.show) {
            this.fetchTopicOptions();
            this.fetchCategoryMaster();
        }
    }

    /**
     * 2回目以降のモーダル表示時にselectedCategoriesを最新化する
     * AscModal内部に配置されるため、一度マウントされると再マウントされない
     * → show切替時にpropsから最新データを同期し、最新topic設定を再取得する
     */
    componentDidUpdate(prevProps) {
        if (!prevProps.state.show && this.props.state.show) {
            this.setState({
                selectedCategories: [...(this.props.categories || [])],
                searchText: "",
                errorMessage: null,
                loading: false,
                isDropdownOpen: false,
                topicOutputMax: null,
                loadingTopicOptions: true,
                categoryMaster: [],
                loadingCategoryMaster: true,
            });
            // モーダルopen時に最新のtopic設定と分類マスタを取得
            this.fetchTopicOptions();
            this.fetchCategoryMaster();
        }
    }

    /**
     * チェックボックス変更ハンドラ
     * @param {Object} masterCategory - categoryMasterの要素
     *   { value: "クレーム", label: "クレーム", rgb, font_rgb, data: { id, name, ... } }
     * @param {boolean} isCurrentlyChecked - 現在チェック済みか
     */
    handleCheckChange = async (masterCategory, isCurrentlyChecked) => {
        // 入力バリデーション
        if (!masterCategory || !masterCategory.data || !masterCategory.data.id || !this.props.ht60_id) {
            console.error("Invalid parameters:", { masterCategory: masterCategory, ht60_id: this.props.ht60_id });
            this.props.showErrorObjectMessage({ message: "FindDataError" });
            return;
        }

        const { selectedCategories } = this.state;
        const isMultiTag = this.isMultiTagEnabled();
        const maxCategories = this.getMaxCategories();

        this.setState({ errorMessage: null });

        if (!isMultiTag) {
            // === 単一選択モード ===
            if (isCurrentlyChecked) {
                // OFF時はチェック済み項目の解除操作を無効化（最小1件保証）
                // 変更は「別タグを選んで setCallHistoryCategorySingle」のみ許可
                return;
            } else {
                // チェックON → setCallHistoryCategorySingle で既存を新規1件に統一
                this.setState({ loading: true });
                try {
                    const currentCategory = selectedCategories.length > 0
                        ? selectedCategories[0] : null;

                    if (currentCategory) {
                        // 既存カテゴリあり → setCallHistoryCategorySingle APIで1件に統一
                        const result = await this.props.ascAxios(
                            'post',
                            'Record/setCallHistoryCategorySingle',
                            {
                                ht60_id: this.props.ht60_id,
                                new_category_name: masterCategory.label,
                                new_category_id: masterCategory.data.id
                            }
                        );
                        const updated = result.data.categories || [];
                        this.setState({ selectedCategories: updated });
                        this.props.onCategoriesChange(updated);
                    } else {
                        // 0件状態 → 通常のadd APIで追加
                        const result = await this.props.ascAxios(
                            'post',
                            'Record/addCallHistoryCategory',
                            {
                                ht60_id: this.props.ht60_id,
                                category_name: masterCategory.label,
                                category_id: masterCategory.data.id
                            }
                        );
                        const updated = result.data.categories || [];
                        this.setState({ selectedCategories: updated });
                        this.props.onCategoriesChange(updated);
                    }
                } catch (err) {
                    console.error("setCallHistoryCategorySingle error:", err);
                    this.props.showErrorObjectMessage({ message: "DataUpdateError" });
                } finally {
                    this.setState({ loading: false });
                }
            }
        } else {
            // === 複数選択モード ===
            if (isCurrentlyChecked) {
                // チェックOFF（削除）
                if (selectedCategories.length <= MIN_CATEGORIES) {
                    this.setState({
                        errorMessage: this.props.langText.Message.CategoryMinError
                    });
                    return;
                }

                this.setState({ loading: true });
                try {
                    // 名称で突き合わせた分類は id がマスタと異なるため、
                    // 削除には実際に付いている分類の awt018_id を使う（#553）
                    const target = this.resolveSelected(masterCategory);
                    const result = await this.props.ascAxios(
                        'post',
                        'Record/deleteCallHistoryCategory',
                        {
                            ht60_id: this.props.ht60_id,
                            category_id: (target && target.awt018_id) || masterCategory.data.id
                        }
                    );
                    const updated = result.data.categories || [];
                    this.setState({ selectedCategories: updated });
                    this.props.onCategoriesChange(updated);
                } catch (err) {
                    console.error("deleteCallHistoryCategory error:", err);
                    const errorCode = err.response && err.response.data && err.response.data.code;
                    if (errorCode === "LastTagCannotDelete") {
                        this.setState({
                            errorMessage: this.props.langText.Message.CategoryMinError
                        });
                    } else {
                        this.props.showErrorObjectMessage({ message: "DataDeleteError" });
                    }
                } finally {
                    this.setState({ loading: false });
                }
            } else {
                // チェックON（追加）
                if (selectedCategories.length >= maxCategories) {
                    this.setState({
                        errorMessage: this.props.langText.Message.CategoryMaxError
                    });
                    return;
                }

                this.setState({ loading: true });
                try {
                    const result = await this.props.ascAxios(
                        'post',
                        'Record/addCallHistoryCategory',
                        {
                            ht60_id: this.props.ht60_id,
                            category_name: masterCategory.label,
                            category_id: masterCategory.data.id
                        }
                    );
                    const updated = result.data.categories || [];
                    this.setState({ selectedCategories: updated });
                    this.props.onCategoriesChange(updated);
                } catch (err) {
                    console.error("addCallHistoryCategory error:", err);
                    const errorCode = err.response && err.response.data && err.response.data.code;
                    if (errorCode === "DuplicateData") {
                        this.setState({
                            errorMessage: this.props.langText.Message.CategoryDuplicateError
                        });
                    } else if (errorCode === "MaxTagLimitReached") {
                        this.setState({
                            errorMessage: this.props.langText.Message.CategoryMaxError
                        });
                    } else {
                        this.props.showErrorObjectMessage({ message: "DataUpdateError" });
                    }
                } finally {
                    this.setState({ loading: false });
                }
            }
        }
    }

    /**
     * チェックボックスがチェック済みかどうか
     * awt018_id（カテゴリマスタの一意ID）で判定する。
     * name 比較は Anywhere マスタが name に unique 制約を持たないため、
     * 同名異IDのカテゴリでチェック状態を誤判定する可能性があった。
     */
    isChecked = (masterCategory) => {
        return !!this.resolveSelected(masterCategory);
    }

    /**
     * マスタの1項目に対応する「選択中の分類」を返す（#553）
     *
     * 原則は awt018_id での突き合わせ。ただし過去に他の利用者の ID 空間で付けられた分類は
     * マスタに同じ id が存在しないため、その分類に限って名称で突き合わせる。
     * id がマスタに在る分類は名称では拾わない（同名異IDの誤判定を避けるため）。
     */
    resolveSelected = (masterCategory) => {
        const masterId = masterCategory.data && masterCategory.data.id;
        if (!masterId) return null;

        const byId = this.state.selectedCategories.find(cat => cat.awt018_id === masterId);
        if (byId) return byId;

        const masterIds = (this.state.categoryMaster || [])
            .map(cat => cat.data && cat.data.id)
            .filter(id => id != null);
        const byName = this.state.selectedCategories.find(
            cat => !masterIds.includes(cat.awt018_id) && cat.name === masterCategory.label
        );
        return byName || null;
    }

    /**
     * チェックボックスが無効化されるべきかどうか
     * - loading中（API呼び出し中）は操作不可
     * - loadingTopicOptions中（topic設定取得中）は誤判定防止のため操作不可
     * - 単一選択モード: disabled は行わない（チェック済み項目の解除ガードは handleCheckChange 内で実施）
     * - 複数選択モード: 上限到達時も全項目を表示したまま（クリック時にエラーメッセージで通知）
     */
    isDisabled = (masterCategory) => {
        if (this.state.loading) return true;
        if (this.state.loadingTopicOptions) return true;
        if (this.state.loadingCategoryMaster) return true;

        // 単一・複数いずれのモードでも disabled にしない
        // → 単一モードでのチェック済み解除禁止は handleCheckChange 内の早期リターンで対応
        // → 複数モードでの上限超過は handleCheckChange 内のエラーメッセージで対応
        return false;
    }

    /**
     * 検索フィルタ適用後のマスターリスト
     * selectedCategories にあって categoryMaster にない項目も補完表示する。
     * 一致判定は awt018_id ベース（name 文字列比較は同名異IDで二重表示の原因となる）。
     */
    getFilteredMaster = () => {
        const { searchText, selectedCategories, categoryMaster } = this.state;
        const master = categoryMaster || [];

        // マスターに存在しないが selectedCategories にある項目を補完
        const masterIds = new Set(
            master
                .map(cat => cat.data && cat.data.id)
                .filter(id => id != null)
        );
        // 同じ名称がマスタに在る分類は補完しない。過去に他の利用者の ID 空間で
        // 付けられた分類は id が一致しないため、名称でも重複を弾く（#553）。
        const masterLabels = new Set(master.map(cat => cat.label));
        const supplementary = selectedCategories
            .filter(cat => !masterIds.has(cat.awt018_id) && !masterLabels.has(cat.name))
            .map(cat => ({
                value: `supp-${cat.awt065_id || cat.awt018_id}`,
                label: cat.name,
                rgb: cat.rgb,
                font_rgb: cat.font_rgb,
                data: { id: cat.awt018_id, name: cat.name }
            }));

        const combined = [...supplementary, ...master];

        if (!searchText) return combined;
        return combined.filter(cat =>
            cat.label.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    /**
     * ドロップダウン開閉トグル
     * 閉じる時に0件の場合はエラーメッセージを表示
     */
    toggleDropdown = () => {
        if (this.state.loading) return;
        if (this.state.loadingTopicOptions) return;
        if (this.state.loadingCategoryMaster) return;

        const { isDropdownOpen, selectedCategories } = this.state;

        if (isDropdownOpen && selectedCategories.length === 0) {
            // ドロップダウンを閉じようとした時に0件 → エラー表示して閉じない
            this.setState({
                errorMessage: this.props.langText.Message.CategoryMinError
            });
            return;
        }

        this.setState(prev => ({
            isDropdownOpen: !prev.isDropdownOpen,
            searchText: prev.isDropdownOpen ? "" : prev.searchText,
            errorMessage: null
        }));
    }

    getXBtn = () => {
        return (
            <Button
                className='x-execute'
                onClick={() => this.props.propSetState({ show: false })}
            >
                <FontAwesomeIcon icon={faTimes} />
            </Button>
        );
    }

    render() {
        const { selectedCategories, searchText, errorMessage, isDropdownOpen, loading, loadingTopicOptions, loadingCategoryMaster } = this.state;
        const filteredMaster = this.getFilteredMaster();

        return (
            <Modal
                show={this.props.state.show}
                size="md"
                aria-labelledby="tag-edit-modal"
                className="record-tag-edit-modal"
                backdrop="static"
                centered
                backdropClassName="tag-edit-backdrop"
            >
                <Form horizontal="true">
                    <Modal.Header className="tag-edit-header">
                        <Modal.Title>
                            {this.props.langText.Body.CallCategoryEdit}
                        </Modal.Title>
                        <Button
                            className='x-execute'
                            onClick={() => this.props.propSetState({ show: false })}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                    </Modal.Header>

                    <Modal.Body>
                        {/* エラーメッセージ */}
                        {errorMessage && (
                            <Alert variant="danger" className="tag-edit-error">
                                {errorMessage}
                            </Alert>
                        )}

                        {/* ドロップダウンボタン（付与済みタグ表示 + 開閉） */}
                        <p className="tag-edit-info-text">
                            {this.props.langText.Body.TagEditDescription}
                        </p>
                        <div
                            className={`tag-edit-dropdown-btn ${isDropdownOpen ? 'open' : ''} ${(loading || loadingTopicOptions || loadingCategoryMaster) ? 'loading' : ''}`}
                            onClick={this.toggleDropdown}
                        >
                            <div className="tag-edit-dropdown-tags">
                                {(loading || loadingTopicOptions || loadingCategoryMaster) ? (
                                    <Spinner animation="border" size="sm" className="tag-edit-spinner-inline" />
                                ) : selectedCategories.length > 0 ? (
                                    selectedCategories.map((cat, idx) => (
                                        <span
                                            key={cat.awt065_id || cat.awt018_id || idx}
                                            className="tag-badge"
                                            style={{
                                                backgroundColor: cat.rgb,
                                                color: cat.font_rgb
                                            }}
                                        >
                                            {cat.name}
                                        </span>
                                    ))
                                ) : (
                                    <span className="tag-edit-placeholder">
                                        {this.props.langText.Body.TagEditSearchPlaceholder}
                                    </span>
                                )}
                            </div>
                            <FontAwesomeIcon
                                icon={isDropdownOpen ? faChevronUp : faChevronDown}
                                className="tag-edit-dropdown-icon"
                            />
                        </div>

                        {/* ドロップダウンパネル（展開時のみ表示） */}
                        {isDropdownOpen && (
                            <div className="tag-edit-dropdown-panel">
                                {/* 検索ボックス */}
                                <div className="tag-edit-search">
                                    <FormControl
                                        type="text"
                                        placeholder={this.props.langText.Body.TagEditSearchPlaceholder}
                                        value={searchText}
                                        onChange={e => this.setState({
                                            searchText: e.target.value,
                                            errorMessage: null
                                        })}
                                    />
                                </div>

                                {/* チェックボックス一覧 または ローディング */}
                                {(loading || loadingTopicOptions || loadingCategoryMaster) ? (
                                    <div className="tag-edit-loading">
                                        <Spinner animation="border" size="sm" />
                                        <span className="tag-edit-loading-text">{this.props.langText.Body.TagEditUpdating}</span>
                                    </div>
                                ) : (
                                    <div className="tag-edit-checklist">
                                        {filteredMaster.map((masterCat, idx) => {
                                            const checked = this.isChecked(masterCat);
                                            const disabled = this.isDisabled(masterCat);

                                            return (
                                                <div
                                                    key={(masterCat.data && masterCat.data.id) || masterCat.value || idx}
                                                    className={`tag-edit-item ${disabled ? 'disabled' : ''}`}
                                                >
                                                    <label className="tag-edit-label">
                                                        <input
                                                            type="checkbox"
                                                            checked={checked}
                                                            disabled={disabled}
                                                            onChange={() =>
                                                                this.handleCheckChange(masterCat, checked)
                                                            }
                                                        />
                                                        <span
                                                            className="tag-edit-badge"
                                                            style={{
                                                                backgroundColor: masterCat.rgb,
                                                                color: masterCat.font_rgb
                                                            }}
                                                        >
                                                            {masterCat.label}
                                                        </span>
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* ヘルパーテキスト（ドロップダウン閉じ時のみ表示） */}
                        {!isDropdownOpen && (
                            <p className="tag-edit-info-text tag-edit-info-bottom">
                                {this.props.langText.Body.TagEditNoCategory}
                            </p>
                        )}
                    </Modal.Body>

                    <Modal.Footer className="card-button">
                        <Button
                            className='cancel-execute'
                            onClick={() => this.props.propSetState({ show: false })}
                            variant='outline-secondary'
                        >
                            {this.props.langText.Body.Close}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }
}
